// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#page-container {
  position: relative;
  min-height: 87vh;
}

#app-country-select ::ng-deep .select-button {
  background-color: transparent;
  border: none;
  font-weight: 400;
  color: #222;
}

.country-option,
nb-select-label {
  display: flex;
  align-items: center;
}

.country-image {
  width: 1em;
  height: 1em;
  margin-right: 1em;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlZ2lzdGVyLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0Usa0JBQUE7RUFDQSxnQkFBQTtBQUNGOztBQUlJO0VBQ0UsNkJBQUE7RUFDQSxZQUFBO0VBQ0EsZ0JBQUE7RUFDQSxXQUFBO0FBRE47O0FBS0E7O0VBRUUsYUFBQTtFQUNBLG1CQUFBO0FBRkY7O0FBS0E7RUFDRSxVQUFBO0VBQ0EsV0FBQTtFQUNBLGlCQUFBO0FBRkYiLCJmaWxlIjoicmVnaXN0ZXIuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIjcGFnZS1jb250YWluZXIge1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIG1pbi1oZWlnaHQ6IDg3dmg7XG59XG5cbiNhcHAtY291bnRyeS1zZWxlY3Qge1xuICA6Om5nLWRlZXAge1xuICAgIC5zZWxlY3QtYnV0dG9uIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50O1xuICAgICAgYm9yZGVyOiBub25lO1xuICAgICAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgICAgIGNvbG9yOiAjMjIyO1xuICAgIH1cbiAgfVxufVxuLmNvdW50cnktb3B0aW9uLFxubmItc2VsZWN0LWxhYmVsIHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbn1cblxuLmNvdW50cnktaW1hZ2Uge1xuICB3aWR0aDogMWVtO1xuICBoZWlnaHQ6IDFlbTtcbiAgbWFyZ2luLXJpZ2h0OiAxZW07XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/auth/register/register.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;AACF;;AAII;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AADN;;AAKA;;EAEE,aAAA;EACA,mBAAA;AAFF;;AAKA;EACE,UAAA;EACA,WAAA;EACA,iBAAA;AAFF;AACA,o9BAAo9B","sourcesContent":["#page-container {\n  position: relative;\n  min-height: 87vh;\n}\n\n#app-country-select {\n  ::ng-deep {\n    .select-button {\n      background-color: transparent;\n      border: none;\n      font-weight: 400;\n      color: #222;\n    }\n  }\n}\n.country-option,\nnb-select-label {\n  display: flex;\n  align-items: center;\n}\n\n.country-image {\n  width: 1em;\n  height: 1em;\n  margin-right: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
